import GameServerPublicInfo from "../../models/GameServerPublicInfo";
import axios from "axios";
import BackendClient from "../../BackendClient";


export function getServerPublicInfo(client: BackendClient): Promise<GameServerPublicInfo> {
  return new Promise<GameServerPublicInfo>((resolve, reject) => {
    axios.get(`${client.getBackendUrl()}${BackendClient.GetServerPublicInfoPath}`)
      .then((response) => resolve(response.data))
      .catch((reason) => {
        console.log(`Exception when fetching public info: ${JSON.stringify(reason)}`);
        reject(reason);
      });
  });
}